import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import IotTable from './components/iotTable';

/**
 * Public entry point for the IoT dynamic table. Renders a single Contentful
 * table (`tableList`). When `interactive` (the popup flow) each row owns its
 * in-progress term/quantity selection and signals `onRowComplete` once all of
 * its required fields are selected (or `null` to withdraw a previously
 * completed row). The owning field aggregates the completed products, shows
 * them in the summary table, and emits the totals to the order — this
 * component no longer accumulates totals itself.
 */
const IotTableList = ({
  tableList,
  interactive,
  completedProducts,
  onRowComplete,
  unitFloors,
  isRenewal
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const selectTermPlaceholder = _.get(
    localizedStrings,
    'iotDynamicTable.iotTableList.selectTermPlaceholder',
    'Select a term'
  );

  return (
    <IotTable
      tableList={tableList}
      interactive={interactive}
      selectTermPlaceholder={selectTermPlaceholder}
      completedProducts={completedProducts}
      onRowComplete={interactive ? onRowComplete : null}
      unitFloors={unitFloors}
      isRenewal={isRenewal}
    />
  );
};

IotTableList.propTypes = {
  tableList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  interactive: PropTypes.bool,
  completedProducts: PropTypes.arrayOf(PropTypes.shape({})),
  onRowComplete: PropTypes.func,
  unitFloors: PropTypes.shape({}),
  isRenewal: PropTypes.bool
};

IotTableList.defaultProps = {
  interactive: false,
  completedProducts: [],
  onRowComplete: null,
  unitFloors: null,
  isRenewal: false
};

export default IotTableList;
